export default __webpack_public_path__ + "static/media/avatar-s-2.5283923e.jpg";